import { colorsSets } from "@similarweb/styles";

import { useApiQuery } from "app/modules/api-client";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useActivationSetFavicons } from "../../../hooks/useActivationSetFavicons";
import type { IChartDataItem } from "../../common/widget/donut-metric/types";
import { useDomainColorMap } from "../../common/widget/useDomainColorMap";
import { useCommonAlertsQueryParams } from "../../useCommonAlertsQueryParams";

const colors = colorsSets.c.toArray();

export const useContentActivityQuery = () => {
    const params = useCommonAlertsQueryParams();
    const { activationSet } = useActivationSet();
    const domainColorMap = useDomainColorMap();
    const { favicons } = useActivationSetFavicons();
    const primaryDomain = activationSet?.primaryDomain;

    return useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsMetricsWebsiteContentDetail",
            options: {
                refetchOnMount: true,
                select: (data): { data: IChartDataItem[] }[] | null => {
                    if (!data?.length) {
                        return null;
                    }

                    const maxValue = Math.max(...data.map((item) => item.totalPosts));

                    return [
                        {
                            data: data.map((item, index) => {
                                const isPrimary = item.domain === primaryDomain;
                                const isMaxValue = item.totalPosts === maxValue;

                                return {
                                    id: item.domain,
                                    color: domainColorMap?.[item.domain] ?? colors[index % colors.length],
                                    name: item.domain,
                                    visible: true,
                                    y: item.share,
                                    value: item.totalPosts,
                                    isPrimary,
                                    isMaxValue,
                                    icon: favicons?.[item.domain] ?? null,
                                } satisfies IChartDataItem;
                            }),
                        },
                    ];
                },
            },
        },
        params,
    );
};
